import Colors from "../../../../theme/colors";

const Styles = {
  container: {
    borderRadius: "12px",
    width: "95vw",
    maxWidth: "1200px",
    background: "#FFFFFF",
  },
  typography: {
    color: "#1F26C7",
    marginBottom: 25,
    fontSize: 16,
    fontWeight: 500,
  },

  gridStyle: {
    marginTop: 5,
    marginBottom: 5,
  },

  typographySecondary: {
    marginTop: 20,
    marginBottom: 20,
  },

  buttonStyle: {
    marginTop: 100,
    backgroundColor: Colors.midnightBlue,
    borderRadius: 100,
    width: 150,
    height: 52,
    marginRight: "50%",
  },

  zoneLocatorContainer: {
    display: "flex",
    justifyContent: "row",
    alignItems: "center",
    fontSize: "22px",
    marginTop: "30px",
    cursor: "pointer",
  },

  inputField: {
    marginBottom: 20,
    width: "100%",
  },
  rowStyle: {
    color: "#183053",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  },
  actionBtn: {
    fontSize: "10px",
    width: "100px",
    alignItems: "center",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "12px",
  },
  label: {
    flex: 1,
    color: "#8C8C8C",
    fontSize: "16px",
    width: "30%",
  },
  action: {
    width: "100%",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "15px 0 0 0",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  noDataMsg: {
    color: "#515772",
  },
  submitButtonStyle: {
    marginTop: "30px",
    color: "#FFFFFF",
    borderRadius: 8,
    height: 40,
  },
  largeText: {
    display: "-webkit-box",
    WebkitLineClamp: "3",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  greyTableCell: {
    whiteSpace: "",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
  },
  interviewByNames: {
    border: "1px solid red",
    maxWidth: "30px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#5e5e5e",
    cursor: "pointer",
  },
  tableHeadCells: {
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default Styles;

export const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  mini: {
    maxWidth: "5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
  normal: {
    maxWidth: "15rem",
  },
  large: {
    maxWidth: "18rem",
  },
};
